export default "__VITE_ASSET__Dwo85AtD__"